import script from "./BlogCategoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogCategoryList.vue?vue&type=script&setup=true&lang=js"

import "./BlogCategoryList.vue?vue&type=style&index=0&id=b2632af6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2632af6"]])

export default __exports__